import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../../../shared/components/button/button.component';

export interface HeroSlide {
  id: number;
  image: string;
  headline: string;
  subtext: string;
  ctaText: string;
}

@Component({
  selector: 'app-home-hero-slide',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonComponent],
  templateUrl: './home-hero-slide.component.html',
  styleUrls: ['./home-hero-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeHeroSlideComponent {
  @Input() slide!: HeroSlide;
  @Input() isActive: boolean = false;
}
